import styled from 'styled-components';
import { MENU_HEIGHT, HEADER_HEIGHT } from 'styles/common';
import { RadioWrapper } from 'styles/form';
import colors from 'styles/colors';
import { CheckboxContent } from 'components/Checkbox/styles';
import { LoadingBox } from 'components/Loading/styles';

import { ACTIVE } from 'styles/commonClasses';

export const SELECTABLE = 'selectable';

export const TableContainer = styled.div`
  border: 1px solid ${colors.tableBorder};
  color: ${colors.tableText};
  font-size: 12px;
  height: 100%;
  min-height: inherit;
  overflow: auto;
`;

export const TableContent = styled.table`
  min-width: 100%;
  white-space: nowrap;
`;

export const FullWidthTableContent = styled(TableContent)`
  width: 100%;
`;

export const THead = styled.thead`
  background-color: ${colors.tableHeaderBackground};
  border-bottom: 1px solid ${colors.tableHeaderBorderBottom};
`;

export const HeaderItem = styled.th`
  padding: 0 15px;
  font-weight: 600;
  text-align: left;
  height: 47px;
  vertical-align: middle;
  text-transform: uppercase;

  span {
    opacity: 0.9;
  }

  &:hover i.icon-sort {
    color: ${colors.tableText};
  }
`;

export const HeaderItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Row = styled.tr`
  border-bottom: 1px solid ${colors.tableBorder};
  margin: 0 20px;

  &.${ACTIVE}:not([disabled]),
  .${SELECTABLE} &:hover:not([disabled]) {
    cursor: pointer;
    background-color: ${colors.activeLight};
  }

  &[disabled] {
    color: ${colors.disabledText};
  }
`;

export const Column = styled.td`
  padding: 10px 15px;
  opacity: 0.9;

  input {
    height: 30px;
    max-height: 30px;
    overflow: visible;
    display: inline-block;
  }

  input::-webkit-inner-spin-button {
    font-size: 80%;
    margin: 0;
    padding: 0;
    overflow: visible;
  }

  ${CheckboxContent} {
    margin: 0;
  }
`;

export const TableWrapper = styled.div`
  height: 100%;
  min-height: inherit;
  width: 100%;

  ${RadioWrapper} + & {
    margin-top: 20px;
  }
`;

export const FullSizeTableWrapper = styled.div`
  height: calc(100vh - (${MENU_HEIGHT} + ${HEADER_HEIGHT} + 90px));
`;

export const Screen = styled.div`
  align-items: center;
  background-color: ${colors.white};
  display: flex;
  justify-content: center;
  height: 100%;
  min-height: inherit;
  width: 100%;

  ${LoadingBox} {
    height: 10em;
    width: 10em;
    border-color: ${colors.highlight};
    border-left-color: transparent;
    border-right-color: transparent;
  }
`;
